import React, { useEffect } from 'react';
import styles from './Gallery.module.css';
import SimpleLightbox from 'simplelightbox/dist/simple-lightbox.esm';
import 'simplelightbox/dist/simple-lightbox.min.css';

const Gallery = () => {
  useEffect(() => {
    const lightbox = new SimpleLightbox('.gallery a');

    lightbox.on('show.simplelightbox', function (e) {
      console.log('Image ' + (e.index + 1) + ' shown');
    });

    return () => {
      lightbox.destroy();
    };
  });

  return (
    <section id='galeria' className={styles.gallery_container}>
      <h2> GALERIA</h2>

     

       <span className={styles.gallery_title}>
        Sprawni i Sprawczy
      </span>
      <div className={`gallery a ${styles.gallery_fundacja}`}>
       <a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-1.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-1.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-2.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-2.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-3.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-3.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-4.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-4.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-5.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-5.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-6.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-6.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-7.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-7.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-8.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-8.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-9.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-9.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-10.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-10.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-11.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-11.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-12.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-12.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-13.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-13.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-14.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-14.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-15.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-15.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-16.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-16.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-17.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-17.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-18.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-18.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-19.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-19.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-20.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-20.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-21.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-21.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-22.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-22.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-23.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-23.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-24.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-24.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-25.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-25.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-26.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-26.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-27.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-27.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-28.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-28.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-29.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-29.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-30.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-30.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>

<a href='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-31.jpg'> 
  <img 
    src='/img/galeria/sprawni-i-sprawczy/sprawni-i-sprawczy-31.jpg' 
    alt='Sprawni i Sprawczy' 
    title='Sprawni i Sprawczy' 
  /> 
</a>
      
      </div>


      <span className={styles.gallery_title}>
        Artystyczne wizje wartości europejskich
      </span>
      <div className={`gallery a ${styles.gallery_fundacja}`}>
        <a href='/img/galeria/artystyczne-wizje-1.jpg'>
          <img
            src='/img/galeria/artystyczne-wizje-1-min.jpg'
            alt='Artystyczne wizje wartości europejskich'
            title='Artystyczne wizje wartości europejskich'
          />
        </a>
        <a href='/img/galeria/artystyczne-wizje-2.jpg'>
          <img
            src='/img/galeria/artystyczne-wizje-2-min.jpg'
            alt='Artystyczne wizje wartości europejskich'
            title='Artystyczne wizje wartości europejskich'
          />
        </a>
        <a href='/img/galeria/artystyczne-wizje-3.jpg'>
          <img
            src='/img/galeria/artystyczne-wizje-3-min.jpg'
            alt='Artystyczne wizje wartości europejskich'
            title='Artystyczne wizje wartości europejskich'
          />
        </a>
        <a href='/img/galeria/artystyczne-wizje-4.jpg'>
          <img
            src='/img/galeria/artystyczne-wizje-4-min.jpg'
            alt='Artystyczne wizje wartości europejskich'
            title='Artystyczne wizje wartości europejskich'
          />
        </a>
        <a href='/img/galeria/artystyczne-wizje-5.jpg'>
          <img
            src='/img/galeria/artystyczne-wizje-5-min.jpg'
            alt='Artystyczne wizje wartości europejskich'
            title='Artystyczne wizje wartości europejskich'
          />
        </a>
        <a href='/img/galeria/artystyczne-wizje-6.jpg'>
          <img
            src='/img/galeria/artystyczne-wizje-6-min.jpg'
            alt='Artystyczne wizje wartości europejskich'
            title='Artystyczne wizje wartości europejskich'
          />
        </a>
        <a href='/img/galeria/artystyczne-wizje-7.jpg'>
          <img
            src='/img/galeria/artystyczne-wizje-7-min.jpg'
            alt='Artystyczne wizje wartości europejskich'
            title='Artystyczne wizje wartości europejskich'
          />
        </a>
        <a href='/img/galeria/artystyczne-wizje-8.jpg'>
          <img
            src='/img/galeria/artystyczne-wizje-8-min.jpg'
            alt='Artystyczne wizje wartości europejskich'
            title='Artystyczne wizje wartości europejskich'
          />
        </a>
      </div>

      <span className={styles.gallery_title}>
        Wystawa poplenerowa SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024
        roku
      </span>
      <div className={`gallery a ${styles.gallery_fundacja}`}>
        <a href='/img/galeria/wystawa-poplenerowa-1.jpg'>
          <img
            src='/img/galeria/wystawa-poplenerowa-1-min.jpg'
            alt=' Wystawa poplenerowa  SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024 roku'
            title=' Wystawa poplenerowa  SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024 roku'
          />
        </a>
        <a href='/img/galeria/wystawa-poplenerowa-2.jpg'>
          <img
            src='/img/galeria/wystawa-poplenerowa-2-min.jpg'
            alt='Wystawa poplenerowa  SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024 roku'
            title='Wystawa poplenerowa  SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024 roku'
          />
        </a>
        <a href='/img/galeria/wystawa-poplenerowa-3.jpg'>
          <img
            src='/img/galeria/wystawa-poplenerowa-3-min.jpg'
            alt='Wystawa poplenerowa  SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024 roku'
            title='Wystawa poplenerowa  SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024 roku'
          />
        </a>
        <a href='/img/galeria/wystawa-poplenerowa-4.jpg'>
          <img
            src='/img/galeria/wystawa-poplenerowa-4-min.jpg'
            alt='Wystawa poplenerowa  SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024 roku'
            title='Wystawa poplenerowa  SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024 roku'
          />
        </a>
        <a href='/img/galeria/wystawa-poplenerowa-5.jpg'>
          <img
            src='/img/galeria/wystawa-poplenerowa-5-min.jpg'
            alt='Wystawa poplenerowa  SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024 roku'
            title='Wystawa poplenerowa  SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024 roku'
          />
        </a>
        <a href='/img/galeria/wystawa-poplenerowa-6.jpg'>
          <img
            src='/img/galeria/wystawa-poplenerowa-6-min.jpg'
            alt='Wystawa poplenerowa  SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024 roku'
            title='Wystawa poplenerowa  SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024 roku'
          />
        </a>
        <a href='/img/galeria/wystawa-poplenerowa-7.jpg'>
          <img
            src='/img/galeria/wystawa-poplenerowa-7-min.jpg'
            alt='Wystawa poplenerowa  SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024 roku'
            title='Wystawa poplenerowa  SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024 roku'
          />
        </a>
        <a href='/img/galeria/wystawa-poplenerowa-8.jpg'>
          <img
            src='/img/galeria/wystawa-poplenerowa-8-min.jpg'
            alt='Wystawa poplenerowa  SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024 roku'
            title='Wystawa poplenerowa  SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024 roku'
          />
        </a>
        <a href='/img/galeria/wystawa-poplenerowa-9.jpg'>
          <img
            src='/img/galeria/wystawa-poplenerowa-9-min.jpg'
            alt='Wystawa poplenerowa  SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024 roku'
            title='Wystawa poplenerowa  SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024 roku'
          />
        </a>
        <a href='/img/galeria/wystawa-poplenerowa-10.jpg'>
          <img
            src='/img/galeria/wystawa-poplenerowa-10-min.jpg'
            alt='Wystawa poplenerowa  SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024 roku'
            title='Wystawa poplenerowa  SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024 roku'
          />
        </a>
        <a href='/img/galeria/wystawa-poplenerowa-11.jpg'>
          <img
            src='/img/galeria/wystawa-poplenerowa-11-min.jpg'
            alt='Wystawa poplenerowa  SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024 roku'
            title='Wystawa poplenerowa  SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024 roku'
          />
        </a>
        <a href='/img/galeria/wystawa-poplenerowa-12.jpg'>
          <img
            src='/img/galeria/wystawa-poplenerowa-12-min.jpg'
            alt='Wystawa poplenerowa  SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024 roku'
            title=' Wystawa poplenerowa  SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024 roku'
          />
        </a>
        <a href='/img/galeria/wystawa-poplenerowa-13.jpg'>
          <img
            src='/img/galeria/wystawa-poplenerowa-13-min.jpg'
            alt='Wystawa poplenerowa  SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024 roku'
            title='Wystawa poplenerowa  SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024 roku'
          />
        </a>
        <a href='/img/galeria/wystawa-poplenerowa-14.jpg'>
          <img
            src='/img/galeria/wystawa-poplenerowa-14-min.jpg'
            alt='Wystawa poplenerowa  SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024 roku'
            title='Wystawa poplenerowa  SZTUKA W ŚWIETLE WARTOŚCI UNIJNYCH, 11 czerwca 2024 roku'
          />
        </a>
      </div>

      <span className={styles.gallery_title}>
        Plener
      </span>
      <div className={`gallery a ${styles.gallery_fundacja}`}>
        <a href='/img/galeria/plener-1.jpg'>
          <img
            src='/img/galeria/plener-1-min.jpg'
            alt='Plener'
            title='Plener  '
          />
        </a>
        <a href='/img/galeria/plener-2.jpg'>
          <img
            src='/img/galeria/plener-2-min.jpg'
            alt='Plener  '
            title='Plener  '
          />
        </a>
        <a href='/img/galeria/plener-3.jpg'>
          <img
            src='/img/galeria/plener-3-min.jpg'
            alt='Plener  '
            title='Plener  '
          />
        </a>
        <a href='/img/galeria/plener-4.jpg'>
          <img
            src='/img/galeria/plener-4-min.jpg'
            alt='Plener  '
            title='Plener  '
          />
        </a>
        <a href='/img/galeria/plener-5.jpg'>
          <img
            src='/img/galeria/plener-5-min.jpg'
            alt='Plener  '
            title='Plener  '
          />
        </a>
        <a href='/img/galeria/plener-6.jpg'>
          <img
            src='/img/galeria/plener-6-min.jpg'
            alt='Plener  '
            title='Plener  '
          />
        </a>
        <a href='/img/galeria/plener-7.jpg'>
          <img
            src='/img/galeria/plener-7-min.jpg'
            alt='Plener  '
            title='Plener  '
          />
        </a>
        <a href='/img/galeria/plener-8.jpg'>
          <img
            src='/img/galeria/plener-8-min.jpg'
            alt='Plener  '
            title='Plener  '
          />
        </a>
        <a href='/img/galeria/plener-9.jpg'>
          <img
            src='/img/galeria/plener-9-min.jpg'
            alt='Plener  '
            title='Plener  '
          />
        </a>
        <a href='/img/galeria/plener-10.jpg'>
          <img
            src='/img/galeria/plener-10-min.jpg'
            alt='Plener  '
            title='Plener  '
          />
        </a>
        </div>

      <span className={styles.gallery_title}>
        Pierwszy dzień Konferencji o wartościach, 16 maja 2024
      </span>
      <div className={`gallery a ${styles.gallery_fundacja}`}>
        <a href='/img/galeria/pierwszy-dzien-konferencji-o-wartosciach-1.jpg'>
          <img
            src='/img/galeria/pierwszy-dzien-konferencji-o-wartosciach-1-min.jpg'
            alt='Pierwszy dzień Konferencji o wartościach, 16 maja 2024'
            title='Pierwszy dzień Konferencji o wartościach, 16 maja 2024'
          />
        </a>
        <a href='/img/galeria/pierwszy-dzien-konferencji-o-wartosciach-2.jpg'>
          <img
            src='/img/galeria/pierwszy-dzien-konferencji-o-wartosciach-2-min.jpg'
            alt='Pierwszy dzień Konferencji o wartościach, 16 maja 2024'
            title='Pierwszy dzień Konferencji o wartościach, 16 maja 2024'
          />
        </a>
        <a href='/img/galeria/pierwszy-dzien-konferencji-o-wartosciach-3.jpg'>
          <img
            src='/img/galeria/pierwszy-dzien-konferencji-o-wartosciach-3-min.jpg'
            alt='Pierwszy dzień Konferencji o wartościach, 16 maja 2024'
            title='Pierwszy dzień Konferencji o wartościach, 16 maja 2024'
          />
        </a>
        <a href='/img/galeria/pierwszy-dzien-konferencji-o-wartosciach-4.jpg'>
          <img
            src='/img/galeria/pierwszy-dzien-konferencji-o-wartosciach-4-min.jpg'
            alt='Pierwszy dzień Konferencji o wartościach, 16 maja 2024'
            title='Pierwszy dzień Konferencji o wartościach, 16 maja 2024'
          />
        </a>
        <a href='/img/galeria/pierwszy-dzien-konferencji-o-wartosciach-5.jpg'>
          <img
            src='/img/galeria/pierwszy-dzien-konferencji-o-wartosciach-5-min.jpg'
            alt='Pierwszy dzień Konferencji o wartościach, 16 maja 2024'
            title='Pierwszy dzień Konferencji o wartościach, 16 maja 2024'
          />
        </a>{' '}
        <a href='/img/galeria/pierwszy-dzien-konferencji-o-wartosciach-6.jpg'>
          <img
            src='/img/galeria/pierwszy-dzien-konferencji-o-wartosciach-6-min.jpg'
            alt='Pierwszy dzień Konferencji o wartościach, 16 maja 2024'
            title='Pierwszy dzień Konferencji o wartościach, 16 maja 2024'
          />
        </a>{' '}
        <a href='/img/galeria/pierwszy-dzien-konferencji-o-wartosciach-7.jpg'>
          <img
            src='/img/galeria/pierwszy-dzien-konferencji-o-wartosciach-7-min.jpg'
            alt='Pierwszy dzień Konferencji o wartościach, 16 maja 2024'
            title='Pierwszy dzień Konferencji o wartościach, 16 maja 2024'
          />
        </a>{' '}
        <a href='/img/galeria/pierwszy-dzien-konferencji-o-wartosciach-8.jpg'>
          <img
            src='/img/galeria/pierwszy-dzien-konferencji-o-wartosciach-8-min.jpg'
            alt='Pierwszy dzień Konferencji o wartościach, 16 maja 2024'
            title='Pierwszy dzień Konferencji o wartościach, 16 maja 2024'
          />
        </a>{' '}
        <a href='/img/galeria/pierwszy-dzien-konferencji-o-wartosciach-9.jpg'>
          <img
            src='/img/galeria/pierwszy-dzien-konferencji-o-wartosciach-9-min.jpg'
            alt='Pierwszy dzień Konferencji o wartościach, 16 maja 2024'
            title='Pierwszy dzień Konferencji o wartościach, 16 maja 2024'
          />
        </a>{' '}

</div>
        <span className={styles.gallery_title}>
        Drugi dzień Konferencji o wartościach, 17 maja 2024
      </span>
      <div className={`gallery a ${styles.gallery_fundacja}`}>

        <a href='/img/galeria/drugi-dzien-konferencji-o-wartosciach-10.jpg'>
          <img
            src='/img/galeria/drugi-dzien-konferencji-o-wartosciach-10-min.jpg'
            alt='Drugi dzień Konferencji o wartościach, 16 maja 2024'
            title='Drugi dzień Konferencji o wartościach, 16 maja 2024'
          />
        </a>{' '}
        <a href='/img/galeria/drugi-dzien-konferencji-o-wartosciach-11.jpg'>
          <img
            src='/img/galeria/drugi-dzien-konferencji-o-wartosciach-11-min.jpg'
            alt='Drugi dzień Konferencji o wartościach, 16 maja 2024'
            title='Drugi dzień Konferencji o wartościach, 16 maja 2024'
          />
        </a>{' '}
        <a href='/img/galeria/drugi-dzien-konferencji-o-wartosciach-12.jpg'>
          <img
            src='/img/galeria/drugi-dzien-konferencji-o-wartosciach-12-min.jpg'
            alt='Drugi dzień Konferencji o wartościach, 16 maja 2024'
            title='Drugi dzień Konferencji o wartościach, 16 maja 2024'
          />
        </a>{' '}
        <a href='/img/galeria/drugi-dzien-konferencji-o-wartosciach-13.jpg'>
          <img
            src='/img/galeria/drugi-dzien-konferencji-o-wartosciach-13-min.jpg'
            alt='Drugi dzień Konferencji o wartościach, 16 maja 2024'
            title='Drugi dzień Konferencji o wartościach, 16 maja 2024'
          />
        </a>{' '}
        <a href='/img/galeria/drugi-dzien-konferencji-o-wartosciach-14.jpg'>
          <img
            src='/img/galeria/drugi-dzien-konferencji-o-wartosciach-14-min.jpg'
            alt='Drugi dzień Konferencji o wartościach, 16 maja 2024'
            title='Drugi dzień Konferencji o wartościach, 16 maja 2024'
          />
        </a>{' '}
        <a href='/img/galeria/drugi-dzien-konferencji-o-wartosciach-15.jpg'>
          <img
            src='/img/galeria/drugi-dzien-konferencji-o-wartosciach-15-min.jpg'
            alt='Drugi dzień Konferencji o wartościach, 16 maja 2024'
            title='Drugi dzień Konferencji o wartościach, 16 maja 2024'
          />
        </a>
      </div>

      <span className={styles.gallery_title}>
        Projekt SPLOTOWE WARTOŚCI (2023/2024)
      </span>
      <div className={`gallery a ${styles.gallery_fundacja}`}>
        <a href='/img/galeria/debata-wiosenna-1.jpg'>
          <img
            src='/img/galeria/debata-wiosenna-1-min.jpg'
            alt='Debata wiosenna w ramach projektu SPLOTOWE WARTOŚCI, 2024'
            title='Debata wiosenna w ramach projektu SPLOTOWE WARTOŚCI, 2024'
          />
        </a>
        <a href='/img/galeria/debata-wiosenna-2.jpg'>
          <img
            src='/img/galeria/debata-wiosenna-2-min.jpg'
            alt='Debata wiosenna w ramach projektu SPLOTOWE WARTOŚCI, 2024'
            title='Debata wiosenna w ramach projektu SPLOTOWE WARTOŚCI, 2024'
          />
        </a>
        <a href='/img/galeria/debata-zimowa-1.jpg'>
          <img
            src='/img/galeria/debata-zimowa-1-min.jpg'
            alt='Debata zimowa w ramach projektu SPLOTOWE WARTOŚCI, 2023'
            title='Debata zimowa w ramach projektu SPLOTOWE WARTOŚCI, 2023'
          />
        </a>
        <a href='/img/galeria/debata-zimowa-2.jpg'>
          <img
            src='/img/galeria/debata-zimowa-2-min.jpg'
            alt='Debata zimowa w ramach projektu SPLOTOWE WARTOŚCI, 2023'
            title='Debata zimowa w ramach projektu SPLOTOWE WARTOŚCI, 2023'
          />
        </a>
        <a href='/img/galeria/debata-zimowa-3.jpg'>
          <img
            src='/img/galeria/debata-zimowa-3-min.jpg'
            alt='Debata zimowa w ramach projektu SPLOTOWE WARTOŚCI, 2023'
            title='Debata zimowa w ramach projektu SPLOTOWE WARTOŚCI, 2023'
          />
        </a>
        <a href='/img/galeria/debata-zimowa-4.jpg'>
          <img
            src='/img/galeria/debata-zimowa-4-min.jpg'
            alt='Debata zimowa w ramach projektu SPLOTOWE WARTOŚCI, 2023'
            title='Debata zimowa w ramach projektu SPLOTOWE WARTOŚCI, 2023'
          />
        </a>
        <a href='/img/galeria/debata-zimowa-5.jpg'>
          <img
            src='/img/galeria/debata-zimowa-5-min.jpg'
            alt='Debata zimowa w ramach projektu SPLOTOWE WARTOŚCI, 2023'
            title='Debata zimowa w ramach projektu SPLOTOWE WARTOŚCI, 2023'
          />
        </a>

        <a href='/img/galeria/warsztaty-1.jpg'>
          <img
            src='/img/galeria/warsztaty-1-min.jpg'
            alt='Warsztaty w ramach projektu SPLOTOWE WARTOŚCI'
            title='Warsztaty w ramach projektu SPLOTOWE WARTOŚCI'
          />
        </a>
        <a href='/img/galeria/warsztaty-2.jpg'>
          <img
            src='/img/galeria/warsztaty-2-min.jpg'
            alt='Warsztaty w ramach projektu SPLOTOWE WARTOŚCI'
            title='Warsztaty w ramach projektu SPLOTOWE WARTOŚCI'
          />
        </a>
        <a href='/img/galeria/warsztaty-3.jpg'>
          <img
            src='/img/galeria/warsztaty-3-min.jpg'
            alt='Warsztaty w ramach projektu SPLOTOWE WARTOŚCI'
            title='Warsztaty w ramach projektu SPLOTOWE WARTOŚCI'
          />
        </a>
        <a href='/img/galeria/warsztaty-4.jpg'>
          <img
            src='/img/galeria/warsztaty-4-min.jpg'
            alt='Warsztaty w ramach projektu SPLOTOWE WARTOŚCI'
            title='Warsztaty w ramach projektu SPLOTOWE WARTOŚCI'
          />
        </a>
        <a href='/img/galeria/warsztaty-5.jpg'>
          <img
            src='/img/galeria/warsztaty-5-min.jpg'
            alt='Warsztaty w ramach projektu SPLOTOWE WARTOŚCI'
            title='Warsztaty w ramach projektu SPLOTOWE WARTOŚCI'
          />
        </a>
        <a href='/img/galeria/warsztaty-psychologiczne-1.jpg'>
          <img
            src='/img/galeria/warsztaty-psychologiczne-1-min.jpg'
            alt='Warsztaty psychologiczne w ramach projektu SPLOTOWE WARTOŚCI'
            title='Warsztaty psychologiczne w ramach projektu SPLOTOWE WARTOŚCI'
          />
        </a>
        <a href='/img/galeria/warsztaty-psychologiczne-2.jpg'>
          <img
            src='/img/galeria/warsztaty-psychologiczne-2-min.jpg'
            alt='Warsztaty psychologiczne w ramach projektu SPLOTOWE WARTOŚCI'
            title='Warsztaty psychologiczne w ramach projektu SPLOTOWE WARTOŚCI'
          />
        </a>
        <a href='/img/galeria/warsztaty-psychologiczne-3.jpg'>
          <img
            src='/img/galeria/warsztaty-psychologiczne-3-min.jpg'
            alt='Warsztaty psychologiczne w ramach projektu SPLOTOWE WARTOŚCI'
            title='Warsztaty psychologiczne w ramach projektu SPLOTOWE WARTOŚCI'
          />
        </a>
        <a href='/img/galeria/warsztaty-psychologiczne-4.jpg'>
          <img
            src='/img/galeria/warsztaty-psychologiczne-4-min.jpg'
            alt='Warsztaty psychologiczne w ramach projektu SPLOTOWE WARTOŚCI'
            title='Warsztaty psychologiczne w ramach projektu SPLOTOWE WARTOŚCI'
          />
        </a>
        <a href='/img/galeria/warsztaty-psychologiczne-5.jpg'>
          <img
            src='/img/galeria/warsztaty-psychologiczne-5-min.jpg'
            alt='Warsztaty psychologiczne w ramach projektu SPLOTOWE WARTOŚCI'
            title='Warsztaty psychologiczne w ramach projektu SPLOTOWE WARTOŚCI'
          />
        </a>
        <a href='/img/galeria/warsztaty-z-etyki-1.jpg'>
          <img
            src='/img/galeria/warsztaty-z-etyki-1-min.jpg'
            alt='Warsztaty z etyki w ramach projektu SPLOTOWE WARTOŚCI'
            title='Warsztaty z etyki w ramach projektu SPLOTOWE WARTOŚCI'
          />
        </a>
        <a href='/img/galeria/warsztaty-z-etyki-2.jpg'>
          <img
            src='/img/galeria/warsztaty-z-etyki-2-min.jpg'
            alt='Warsztaty z etyki w ramach projektu SPLOTOWE WARTOŚCI'
            title='Warsztaty z etyki w ramach projektu SPLOTOWE WARTOŚCI'
          />
        </a>
        <a href='/img/galeria/warsztaty-z-etyki-3.jpg'>
          <img
            src='/img/galeria/warsztaty-z-etyki-3-min.jpg'
            alt='Warsztaty z etyki w ramach projektu SPLOTOWE WARTOŚCI'
            title='Warsztaty z etyki w ramach projektu SPLOTOWE WARTOŚCI'
          />
        </a>
        <a href='/img/galeria/warsztaty-z-etyki-4.jpg'>
          <img
            src='/img/galeria/warsztaty-z-etyki-4-min.jpg'
            alt='Warsztaty z etyki w ramach projektu SPLOTOWE WARTOŚCI'
            title='Warsztaty z etyki w ramach projektu SPLOTOWE WARTOŚCI'
          />
        </a>
        <a href='/img/galeria/warsztaty-z-etyki-5.jpg'>
          <img
            src='/img/galeria/warsztaty-z-etyki-5-min.jpg'
            alt='Warsztaty z etyki w ramach projektu SPLOTOWE WARTOŚCI'
            title='Warsztaty z etyki w ramach projektu SPLOTOWE WARTOŚCI'
          />
        </a>
        <a href='/img/galeria/warsztaty-z-prawnikiem-1.jpg'>
          <img
            src='/img/galeria/warsztaty-z-prawnikiem-1-min.jpg'
            alt='Warsztaty z prawnikiem w ramach projektu SPLOTOWE WARTOŚCI'
            title='Warsztaty z prawnikiem w ramach projektu SPLOTOWE WARTOŚCI'
          />
        </a>
        <a href='/img/galeria/warsztaty-z-prawnikiem-2.jpg'>
          <img
            src='/img/galeria/warsztaty-z-prawnikiem-2-min.jpg'
            alt='Warsztaty z prawnikiem w ramach projektu SPLOTOWE WARTOŚCI'
            title='Warsztaty z prawnikiem w ramach projektu SPLOTOWE WARTOŚCI'
          />
        </a>
        <a href='/img/galeria/warsztaty-z-prawnikiem-3.jpg'>
          <img
            src='/img/galeria/warsztaty-z-prawnikiem-3-min.jpg'
            alt='Warsztaty z prawnikiem w ramach projektu SPLOTOWE WARTOŚCI'
            title='Warsztaty z prawnikiem w ramach projektu SPLOTOWE WARTOŚCI'
          />
        </a>
        <a href='/img/galeria/warsztaty-z-prawnikiem-4.jpg'>
          <img
            src='/img/galeria/warsztaty-z-prawnikiem-4-min.jpg'
            alt='Warsztaty z prawnikiem w ramach projektu SPLOTOWE WARTOŚCI'
            title='Warsztaty z prawnikiem w ramach projektu SPLOTOWE WARTOŚCI'
          />
        </a>
      </div>

      <span className={styles.gallery_title}>
        Wystawa rzeźby Stanisława Strzyżyńskiego w Kazimierzu Dolnym, 2024
      </span>

      <div className={`gallery a ${styles.gallery_fundacja}`}>
        <a href='/img/galeria/wystawa-rzezby-stanislawa-strzyzynskiego-w-kazimierzu-dolnym-1.jpg'>
          <img
            src='/img/galeria/wystawa-rzezby-stanislawa-strzyzynskiego-w-kazimierzu-dolnym-1-min.jpg'
            alt='Wystawa rzeźby Stanisława Strzyżyńskiego w Kazimierzu Dolnym, 2024'
            title='Wystawa rzeźby Stanisława Strzyżyńskiego w Kazimierzu Dolnym, 2024'
          />
        </a>

        <a href='/img/galeria/wystawa-rzezby-stanislawa-strzyzynskiego-w-kazimierzu-dolnym-2.jpg'>
          <img
            src='/img/galeria/wystawa-rzezby-stanislawa-strzyzynskiego-w-kazimierzu-dolnym-2-min.jpg'
            alt='Wystawa rzeźby Stanisława Strzyżyńskiego w Kazimierzu Dolnym, 2024'
            title='Wystawa rzeźby Stanisława Strzyżyńskiego w Kazimierzu Dolnym, 2024'
          />
        </a>
        <a href='/img/galeria/wystawa-rzezby-stanislawa-strzyzynskiego-w-kazimierzu-dolnym-3.jpg'>
          <img
            src='/img/galeria/wystawa-rzezby-stanislawa-strzyzynskiego-w-kazimierzu-dolnym-3-min.jpg'
            alt='Wystawa rzeźby Stanisława Strzyżyńskiego w Kazimierzu Dolnym, 2024'
            title='Wystawa rzeźby Stanisława Strzyżyńskiego w Kazimierzu Dolnym, 2024'
          />
        </a>
        <a href='/img/galeria/wystawa-rzezby-stanislawa-strzyzynskiego-w-kazimierzu-dolnym-4.jpg'>
          <img
            src='/img/galeria/wystawa-rzezby-stanislawa-strzyzynskiego-w-kazimierzu-dolnym-4-min.jpg'
            alt='Wystawa rzeźby Stanisława Strzyżyńskiego w Kazimierzu Dolnym, 2024'
            title='Wystawa rzeźby Stanisława Strzyżyńskiego w Kazimierzu Dolnym, 2024'
          />
        </a>
        <a href='/img/galeria/wystawa-rzezby-stanislawa-strzyzynskiego-w-kazimierzu-dolnym-5.jpg'>
          <img
            src='/img/galeria/wystawa-rzezby-stanislawa-strzyzynskiego-w-kazimierzu-dolnym-5-min.jpg'
            alt='Wystawa rzeźby Stanisława Strzyżyńskiego w Kazimierzu Dolnym, 2024'
            title='Wystawa rzeźby Stanisława Strzyżyńskiego w Kazimierzu Dolnym, 2024'
          />
        </a>
        <a href='/img/galeria/wystawa-rzezby-stanislawa-strzyzynskiego-w-kazimierzu-dolnym-6.jpg'>
          <img
            src='/img/galeria/wystawa-rzezby-stanislawa-strzyzynskiego-w-kazimierzu-dolnym-6-min.jpg'
            alt='Wystawa rzeźby Stanisława Strzyżyńskiego w Kazimierzu Dolnym, 2024'
            title='Wystawa rzeźby Stanisława Strzyżyńskiego w Kazimierzu Dolnym, 2024'
          />
        </a>
        <a href='/img/galeria/wystawa-rzezby-stanislawa-strzyzynskiego-w-kazimierzu-dolnym-7.jpg'>
          <img
            src='/img/galeria/wystawa-rzezby-stanislawa-strzyzynskiego-w-kazimierzu-dolnym-7-min.jpg'
            alt='Wystawa rzeźby Stanisława Strzyżyńskiego w Kazimierzu Dolnym, 2024'
            title='Wystawa rzeźby Stanisława Strzyżyńskiego w Kazimierzu Dolnym, 2024'
          />
        </a>
      </div>

      <span className={styles.gallery_title}>
        Jubileusz setnej rocznicy urodzin Stanisława Strzyżyńskiego w
        Nałęczowie, 2023
      </span>

      <div className={`gallery a ${styles.gallery_fundacja}`}>
        <a href='/img/galeria/jubileusz-100-rocznicy-urodzin-stanislawa-strzyzynskiego-w-naleczowie-1.jpg'>
          <img
            src='/img/galeria/jubileusz-100-rocznicy-urodzin-stanislawa-strzyzynskiego-w-naleczowie-1-min.jpg'
            alt='Jubileusz setnej rocznicy urodzin Stanisława Strzyżyńskiego w Nałęczowie, 2023'
            title='Jubileusz setnej rocznicy urodzin Stanisława Strzyżyńskiego w Nałęczowie, 2023'
          />
        </a>
        <a href='/img/galeria/jubileusz-100-rocznicy-urodzin-stanislawa-strzyzynskiego-w-naleczowie-2.jpg'>
          <img
            src='/img/galeria/jubileusz-100-rocznicy-urodzin-stanislawa-strzyzynskiego-w-naleczowie-2-min.jpg'
            alt='Jubileusz setnej rocznicy urodzin Stanisława Strzyżyńskiego w Nałęczowie, 2023'
            title='Jubileusz setnej rocznicy urodzin Stanisława Strzyżyńskiego w Nałęczowie, 2023'
          />
        </a>
        <a href='/img/galeria/jubileusz-100-rocznicy-urodzin-stanislawa-strzyzynskiego-w-naleczowie-3.jpg'>
          <img
            src='/img/galeria/jubileusz-100-rocznicy-urodzin-stanislawa-strzyzynskiego-w-naleczowie-3-min.jpg'
            alt='Jubileusz setnej rocznicy urodzin Stanisława Strzyżyńskiego w Nałęczowie, 2023'
            title='Jubileusz setnej rocznicy urodzin Stanisława Strzyżyńskiego w Nałęczowie, 2023'
          />
        </a>
        <a href='/img/galeria/jubileusz-100-rocznicy-urodzin-stanislawa-strzyzynskiego-w-naleczowie-4.jpg'>
          <img
            src='/img/galeria/jubileusz-100-rocznicy-urodzin-stanislawa-strzyzynskiego-w-naleczowie-4-min.jpg'
            alt='Jubileusz setnej rocznicy urodzin Stanisława Strzyżyńskiego w Nałęczowie, 2023'
            title='Jubileusz setnej rocznicy urodzin Stanisława Strzyżyńskiego w Nałęczowie, 2023'
          />
        </a>
        <a href='/img/galeria/jubileusz-100-rocznicy-urodzin-stanislawa-strzyzynskiego-w-naleczowie-6.jpg'>
          <img
            src='/img/galeria/jubileusz-100-rocznicy-urodzin-stanislawa-strzyzynskiego-w-naleczowie-6-min.jpg'
            alt='Jubileusz setnej rocznicy urodzin Stanisława Strzyżyńskiego w Nałęczowie, 2023'
            title='Jubileusz setnej rocznicy urodzin Stanisława Strzyżyńskiego w Nałęczowie, 2023'
          />
        </a>
        <a href='/img/galeria/jubileusz-100-rocznicy-urodzin-stanislawa-strzyzynskiego-w-naleczowie-7.jpg'>
          <img
            src='/img/galeria/jubileusz-100-rocznicy-urodzin-stanislawa-strzyzynskiego-w-naleczowie-7-min.jpg'
            alt='Jubileusz setnej rocznicy urodzin Stanisława Strzyżyńskiego w Nałęczowie, 2023'
            title='Jubileusz setnej rocznicy urodzin Stanisława Strzyżyńskiego w Nałęczowie, 2023'
          />
        </a>
        <a href='/img/galeria/jubileusz-100-rocznicy-urodzin-stanislawa-strzyzynskiego-w-naleczowie-8.jpg'>
          <img
            src='/img/galeria/jubileusz-100-rocznicy-urodzin-stanislawa-strzyzynskiego-w-naleczowie-8-min.jpg'
            alt='Jubileusz setnej rocznicy urodzin Stanisława Strzyżyńskiego w Nałęczowie, 2023'
            title='Jubileusz setnej rocznicy urodzin Stanisława Strzyżyńskiego w Nałęczowie, 2023'
          />
        </a>
        <a href='/img/galeria/jubileusz-100-rocznicy-urodzin-stanislawa-strzyzynskiego-w-naleczowie-9.jpg'>
          <img
            src='/img/galeria/jubileusz-100-rocznicy-urodzin-stanislawa-strzyzynskiego-w-naleczowie-9-min.jpg'
            alt='Jubileusz setnej rocznicy urodzin Stanisława Strzyżyńskiego w Nałęczowie, 2023'
            title='Jubileusz setnej rocznicy urodzin Stanisława Strzyżyńskiego w Nałęczowie, 2023'
          />
        </a>
      </div>
    </section>
  );
};

export default Gallery;
